export default __webpack_public_path__ + "static/media/kamson-ia.167c1a42.jpg";